<template>
  <v-container fluid class="access-denied-container pa-0">
    <div class="overlay"></div>
    <div class="particles"></div>

    <v-row align="center" justify="center" class="fill-height mx-0">
      <v-col cols="12" sm="10" md="8" lg="6" xl="4">
        <v-card
          elevation="10"
          class="access-denied-card"
          :style="{ background: 'rgba(255, 255, 255, 0.95)' }"
        >
          <div class="card-decoration top"></div>
          <div class="card-decoration bottom"></div>

          <div class="text-center pt-12 pb-8">
            <div class="avatar-container mb-4">
              <v-avatar size="120" class="error main-avatar">
                <v-icon dark size="64">mdi-shield-lock</v-icon>
              </v-avatar>
              <div class="avatar-ring"></div>
              <div class="avatar-ring delay-1"></div>
              <div class="avatar-ring delay-2"></div>
            </div>

            <div class="error-code mb-2">
              <span class="digit">4</span>
              <span class="digit">0</span>
              <span class="digit">3</span>
            </div>

            <h2 class="text-h4 font-weight-bold mb-6 title-gradient">Acceso Denegado</h2>

            <v-card-text>
              <p class="text-h6 grey--text text--darken-1 mb-8">
                No tienes los permisos necesarios para acceder a esta página.
              </p>

              <div class="error-details pa-4 mb-8">
                <div class="alert-icon-container mr-3">
                  <v-icon color="warning">mdi-alert-circle</v-icon>
                </div>
                <span class="grey--text text--darken-2">
                  Si necesitas acceso, por favor contacta al administrador del sistema.
                </span>
              </div>
            </v-card-text>

            <v-card-actions class="justify-center pb-8">
              <v-btn
                color="primary"
                x-large
                rounded
                elevation="4"
                min-width="200"
                @click="goHome"
                class="action-button"
              >
                <v-icon left>mdi-home</v-icon>
                <span>Volver al Inicio</span>
              </v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "AccessDenied",
  methods: {
    goHome() {
      this.$router.push({ name: "Home" });
    },
  },
};
</script>

<style scoped>
.access-denied-container {
  min-height: 100vh;
  position: relative;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, transparent 0%, rgba(0, 0, 0, 0.2) 100%);
}

.particles {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(
      circle at 25% 25%,
      rgba(255, 255, 255, 0.2) 1px,
      transparent 1px
    ),
    radial-gradient(circle at 75% 75%, rgba(255, 255, 255, 0.2) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: particleMove 20s linear infinite;
}

@keyframes particleMove {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 50px 50px;
  }
}

.access-denied-card {
  border-radius: 20px !important;
  overflow: hidden;
  position: relative;
  backdrop-filter: blur(10px);
}

.card-decoration {
  position: absolute;
  width: 300px;
  height: 300px;
  border-radius: 50%;
}

.card-decoration.top {
  top: -150px;
  right: -150px;
  background: linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%);
  opacity: 0.1;
}

.card-decoration.bottom {
  bottom: -150px;
  left: -150px;
  background: linear-gradient(45deg, #a18cd1 0%, #fbc2eb 100%);
  opacity: 0.1;
}

.avatar-container {
  position: relative;
  width: 120px;
  height: 120px;
  margin: 0 auto;
}

.main-avatar {
  position: relative;
  z-index: 2;
  box-shadow: 0 0 30px rgba(244, 67, 54, 0.5);
}

.avatar-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
  border: 2px solid rgba(244, 67, 54, 0.5);
  border-radius: 50%;
  animation: ringPulse 2s infinite;
}

.delay-1 {
  animation-delay: 0.5s;
}

.delay-2 {
  animation-delay: 1s;
}

@keyframes ringPulse {
  0% {
    width: 120px;
    height: 120px;
    opacity: 1;
  }
  100% {
    width: 200px;
    height: 200px;
    opacity: 0;
  }
}

.error-code {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.digit {
  font-size: 3.5rem;
  font-weight: bold;
  color: #f44336;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  animation: bounce 1s infinite;
}

.digit:nth-child(2) {
  animation-delay: 0.2s;
}

.digit:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.title-gradient {
  background: linear-gradient(45deg, #1e3c72, #2a5298);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.error-details {
  background: linear-gradient(135deg, rgba(255, 249, 196, 0.5), rgba(255, 249, 196, 0.8));
  border: 1px solid rgba(251, 140, 0, 0.2);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.alert-icon-container {
  background: rgba(251, 140, 0, 0.1);
  padding: 8px;
  border-radius: 50%;
}

.action-button {
  background: linear-gradient(45deg, #1e3c72, #2a5298) !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease !important;
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(42, 82, 152, 0.3) !important;
}

.action-button span {
  font-weight: 500;
  letter-spacing: 0.5px;
}
</style>
